<template>
  <div class="first_page section section_bg">
    <loading-block v-if="is_load==false" :loading="!is_load"/>
    <section v-if="is_load"  class="">
      <div class="container mobile_div  pt-2 pb-2">
        <div class="row second_section mt-2 mb-4  col-12">
          <div class="row col-md-6 mb-2 mt-2 col-12">
          <div class="col-12  col-md-6">
            <label class=" m-3">Выберите категорию</label>
          </div>
          <div class="col-12 col-md-6">
            <select class="form-control mt-2" @change="changeCategory" v-model="choose_category" >
              <option value="0">Все категории</option>
              <option v-for="(category,category_index) in categorys"  :value="category.last_id" :key="category.last_id">{{ category.title}}</option>

            </select>
          </div>
          </div>
          <div class="row  mb-2 mt-2 col-md-6 col-12">
            <div class="col-12 col-md-6">
              <input type="text" v-model="q_search" placeholder="Введите фразу" class="mt-2 form-control"/>
            </div>
            <div class="col-12 col-md-6 d-flex justify-content-center">
               <button class="btn mt-2" @click="changeCategory" >Найти</button>
            </div>
          </div>

        </div>
        <div class="card alert alert-warning" v-if="is_error">
          <p v-html="error_message"></p>
        </div>
        <div class="row second_section d-flex justify-content-center mt-2 mb-4  col-12" v-if="items.length>0">

          <div class="col-6 col-sm-6 col-lg-2 col-md-3 item_card_container padding_left_right_5   "  v-for="(item,item_index) in items" :key="item_index" >
          <div class="item_card_mini">
           <div class="item_data">
             <div class="shop-item-image">
               <router-link class="" :to="{name: 'shop_item_id', params: {id:item.last_id }}" tag="a" ><v-lazy-image :src="item.photos[0]"  alt="..."/></router-link>
             </div>


             <div class="shop-item-title d-flex justify-content-center"> <router-link class=" " :to="{name: 'shop_item_id', params: {id:item.last_id }}" tag="a" > {{ item.title}}</router-link></div>
             <p><span class="shop-item-price">{{ item.price}} {{ item.currency}}</span></p>
             <!--            <div class="row text-center">-->

             <!--                <h3>{{ item.count}}</h3>-->

             <!--            </div>-->
             <!--            <div class="row mb-2">-->
             <!--              <div class="col-5">-->
             <!--                <button type="button" @click="changeType(item_index,'-')" class="btn" v-if="count_arr['last_id_'+item.last_id]>0">-</button>-->
             <!--              </div>-->

             <!--              <div class="col-5">-->
             <!--                <button type="button" @click="changeType(item_index,'+')" class="btn">+</button>-->

             <!--              </div>-->
             <!--            </div>-->

             <a href="#" class="btn btn-sm" @click="addToCart(item_index)">В корзину</a>
           </div>
            </div>

          </div>

        </div>
        <div class="notify_card card col-lg-12 mt-4 section_gray_bg  " v-if="total>offset">
          <div class="row second_section d-flex justify-content-center">
            <button class="btn" @click="loadItems()">Загрузить еще</button>

          </div>
        </div>
      </div>

    </section>
   </div>
</template>

<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Modal from "@/components/Modal";
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import VLazyImage from "v-lazy-image/v2";




var Avatar = require('vue-avatar');


export default {
  name: 'ShopCategorys',

  components: {LoadingBlock,VLazyImage},
  data() {
    return {
      "is_load":false,
      "categorys":[],
      "count_arr":{},
      'limit':24,
      'offset':0,
      'total':0,
      "choose_category":0,
      'q_search':"",
      "items":[],
      'item':{},
      "is_error":false,
      "error_message":"",
    }
  },
  mounted() {

    var app=this;

    Api.loadShopCategorys(function(data){

      app.categorys=data.categorys;
      if(app.$route.query.category_id){
        app.choose_category=app.$route.query.category_id;
      }
      app.loadItems();

      app.is_load=true;
    });

  },
  methods: {
    changeCategory(){
      var app=this;
      app.offset=0;
      app.items=[];
      app.loadItems();
    },
    changeType(last_id,type){
      var app=this;
      var count_arr=app.count_arr;
      var count=parseInt(app.items[last_id].count);

      if(count>0 && type=="-"){
        count=count-1;

      }else if(type=="+"){
        count=count+1;
      }

      app.isload=false;
  //    Vue.delete(app.cart, 'last_id_'+last_id);
      app.items[last_id].count=0;
      app.items[last_id].count=count;


      app.isload=true;
    },
    changeCount(index_last_id){
      var count=1;
      var app=this;
      if(app.count_arr["last_id_"+index_last_id]>0){
        count=app.count_arr["last_id_"+index_last_id];
      }
      app.count_arr["last_id_"+index_last_id]=count;

    },
    addToCart(index_key){

      var app=this;
      app.item=app.items[index_key];

      if(app.item.count<1){
        app.item.count=1;
      }


      var item={};
      item.last_id=app.item.last_id;
      item.title=app.item.title;
      item.photos=app.item.photos;
      item.user=app.item.user;
      item.price=app.item.price;
      item.user_id=app.item.user_id;
      item.custom_price=app.item.price;
      item.currency=app.item.currency;
      item.options=app.item.options;
      item.custom_options=[];
      item.count=app.item.count;
      item.total_price=parseInt(item.price)*item.count;



      // var query_obj={};
      // if(localStorage.getItem('api_token')){
      //   query_obj.rand_code=localStorage.getItem('api_token');
      // }

      app.is_error=false;
      Api.addToCart(item,function(){
        Api.syncCart();
      },function (err){

        app.is_error=true;
        app.error_message=err;
      });



     // app.custom_options=[];

    //  app.custom_price=parseInt(app.item.price);

    },
    loadItems(){
      var app=this;
      var current_category=app.choose_category;


      Api.loadAllItems(app.limit,app.offset,current_category,app.q_search,function(data){

      if(data.items.length>0){
        var i=0;
        var items=data.items;
        while(items[i]){

           app.count_arr["last_id_"+items[i].last_id]=1;
           items[i].count=1;

          i=i+1;
        }
      }else {
        var items=[];
      }
      app.total=data.total;
      app.offset=data.offset;
      app.items=app.items.concat(items);
      });
    }




  }
};
</script>
